import React, { useEffect, useRef } from "react";

// Looping capture of a real client website (webm + mp4 + poster share one base path).
// Plays only while on screen so a page full of frames stays light.
export const SiteMedia = ({ media, className = "" }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || !("IntersectionObserver" in window)) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) el.play().catch(() => {});
        else el.pause();
      },
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <video
      ref={ref}
      className={className}
      poster={`${media}.jpg`}
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
      data-testid={`site-media-${media.split("/").pop()}`}
    >
      <source src={`${media}.webm`} type="video/webm" />
      <source src={`${media}.mp4`} type="video/mp4" />
    </video>
  );
};

export const BrowserFrame = ({ media, src, host, className = "", dark = false, mediaClass = "" }) => (
  <div
    className={`overflow-hidden rounded-2xl border ${
      dark ? "bg-[#1b1b18] border-white/10" : "bg-white border-black/10"
    } shadow-[0_40px_90px_-30px_rgba(0,0,0,0.5)] ${className}`}
  >
    <div className={`flex items-center gap-2.5 px-4 h-10 ${dark ? "bg-[#26261f]" : "bg-[#ededea]"}`}>
      <span className="flex gap-1.5">
        <i className="block w-2.5 h-2.5 rounded-full bg-[#ff5f57]" />
        <i className="block w-2.5 h-2.5 rounded-full bg-[#febc2e]" />
        <i className="block w-2.5 h-2.5 rounded-full bg-[#28c840]" />
      </span>
      {host && (
        <span
          className={`ml-2 flex-1 truncate text-[11px] px-3 py-1 rounded-full ${
            dark ? "bg-black/40 text-white/45" : "bg-white text-black/45"
          }`}
        >
          {host}
        </span>
      )}
    </div>
    {media ? (
      <SiteMedia media={media} className={`w-full block ${mediaClass}`} />
    ) : (
      <img src={src} alt={host || "web"} loading="lazy" className={`w-full block ${mediaClass}`} />
    )}
  </div>
);

export const PhoneFrame = ({ media, src, className = "" }) => (
  <div
    className={`rounded-[2.2rem] bg-[#141412] p-2 shadow-[0_40px_90px_-25px_rgba(0,0,0,0.6)] border border-white/10 ${className}`}
  >
    <div className="relative rounded-[1.7rem] overflow-hidden bg-black">
      <span className="absolute top-2 left-1/2 -translate-x-1/2 w-14 h-1.5 rounded-full bg-white/25 z-10" />
      {media ? (
        <SiteMedia media={media} className="w-full block" />
      ) : (
        <img src={src} alt="mobilní verze" loading="lazy" className="w-full block" />
      )}
    </div>
  </div>
);

export default BrowserFrame;
